document.addEventListener("DOMContentLoaded", function () {
    console.log("✅ Swatch Collapse Fix Loaded");

    function enableSwatchButton() {
        console.log("✅ Enabling '+ More' Button...");

        document.querySelectorAll(".gsw-list-products-group").forEach(wrapper => {
            let swatches = Array.from(wrapper.querySelectorAll(".gsw-prg-item")); // Convert to array

            // Remove existing "+ More" button to prevent duplication
            wrapper.querySelectorAll(".gsw-more-button").forEach(btn => btn.remove());

            if (swatches.length > 4) {
                let moreButton = document.createElement("button");
                moreButton.innerHTML = "+";
                moreButton.classList.add("gsw-more-button");

                // Insert button **before** the first swatch
                wrapper.insertBefore(moreButton, swatches[0]);

                // **Ensure only the first 4 swatches are visible initially**
                swatches.forEach((swatch, index) => {
                    if (index >= 4) {
                        swatch.style.display = "none"; // Hide extra swatches
                    } else {
                        swatch.style.display = "inline-block"; // Show first 4 swatches
                    }
                });

                // **Expand/collapse swatches on button click**
                moreButton.addEventListener("click", function (event) {
                    event.preventDefault();
                    event.stopPropagation(); // Prevent conflicts with other scripts

                    let isExpanded = wrapper.classList.toggle("expanded");

                    if (isExpanded) {
                        console.log("➡️ Expanding swatches...");
                        swatches.forEach(swatch => swatch.style.display = "inline-block");
                        moreButton.innerHTML = "-";
                    } else {
                        console.log("↩️ Collapsing swatches...");
                        swatches.forEach((swatch, index) => {
                            if (index >= 4) swatch.style.display = "none";
                        });
                        moreButton.innerHTML = "+";
                    }
                });
            }
        });
    }

    function initializeSwatchFix() {
        enableSwatchButton();
    }

    function waitForSwatchFix() {
        let checkExist = setInterval(() => {
            let swatchGroups = document.querySelectorAll(".gsw-list-products-group");

            if (swatchGroups.length > 0) {
                console.log("✅ Swatches detected! Running initializeSwatchFix...");
                clearInterval(checkExist);
                initializeSwatchFix();
            }
        }, 500);
    }

    // 🚀 Fix for Shopify Section Reloads
    document.addEventListener("shopify:section:load", function () {
        console.log("🔄 Shopify Section Reload Detected - Reinitializing Swatch Fix");
        setTimeout(initializeSwatchFix, 500);
    });

    waitForSwatchFix();
});
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('a.add_to_cart_button[data-id]').forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();

      const productId = link.dataset.id;
      const productCard = link.closest('.product-card');
      const productName = productCard?.querySelector('.product-title')?.textContent?.trim() || "Unknown Product";
      const productPrice = parseFloat(productCard?.querySelector('.product-price')?.textContent?.replace(/[^0-9.]/g, '')) || 0;

      // ✅ Shopify AJAX Add to Cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: productId, quantity: 1 })
      })
      .then(res => res.json())
      .then(data => {
        console.log("✅ Product added via AJAX:", data);

        const uniqueID = Date.now();

        // ✅ Klaviyo tracking
        if (window._learnq) {
          window._learnq.push(['track', 'Added to Cart', {
            Name: productName,
            ProductID: productId,
            Brand: "Von Dutch",
            Price: productPrice,
            Quantity: 1,
            URL: window.location.href,
            _unique: uniqueID
          }]);
          console.log("✅ Klaviyo Add to Cart pushed with ID:", uniqueID);
        }

        // ✅ dataLayer push for Shopify pixel or GTM
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "product_added_to_cart",
          ecommerce: {
            items: [{
              item_name: productName,
              item_id: productId,
              price: productPrice,
              quantity: 1
            }]
          }
        });

        console.log("✅ dataLayer Add to Cart event pushed");

        // Optional: show cart drawer or reload
        if (window.location.pathname !== '/cart') {
          fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
              console.log('🛒 Updated Cart:', cart);
              // Optional: refresh mini-cart UI if needed
            });
        }

      })
      .catch(err => {
        console.error("🛑 Error adding to cart:", err);
      });
    });
  });
});
